/* eslint-disable ember/no-computed-properties-in-native-classes */
import { concat } from '@ember/helper';
import { computed } from '@ember/object';
import Component from '@glimmer/component';
import { PrismBadge } from '@mylighthouse/prism-ember';

import styles from './cell-hotel.module.css';

interface SettingsHotelAccessTablesCellsCellHotelSignature {
  Args: {
    value: unknown;
  };
}

export default class SettingsHotelAccessTablesCellsCellHotel extends Component<SettingsHotelAccessTablesCellsCellHotelSignature> {
  // Returns hotels that should be displayed
  @computed('args.value.limitedHotels.@each.hotelinfo')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get displayValue() {
    // @ts-expect-error: Incorrect type
    const names = [];
    // @ts-expect-error: Incorrect type
    if (this.args.value?.limitedHotels) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      this.args.value?.limitedHotels.forEach((element) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (element.hotelinfo !== null) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          names.push(element.hotelinfo.name);
        }
      });
    }
    // @ts-expect-error: Incorrect type
    return names.join(' | ');
  }

  // Return the number of hotels a user has, on top of the diplayed ones
  // eslint-disable-next-line ember/use-brace-expansion
  @computed('args.value.count', 'args.value.limitedHotels.length')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get extraHotels() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return this.args.value?.count - this.args.value?.limitedHotels?.length;
  }

  <template>
    <div
      class={{concat
        styles.hotel-display-value-container
        " "
        "flex items-center"
      }}
    >
      <div class="truncate">
        {{this.displayValue}}
      </div>
      {{#if this.extraHotels}}
        <div class={{styles.extra-hotels-container}}>
          <PrismBadge @label="+&nbsp;{{this.extraHotels}}" />
        </div>
      {{/if}}
    </div>
  </template>
}
